import React, { FC, memo, useState, useCallback } from "react";

import StickyContainer from "../StickyContainer";
import ToggleSwitch from "./ToggleSwitch";
import ShareDrawerContents from "./ShareDrawerContents";
import CardFavoriteButton from "../CardsGrid/CardFavoriteButton";
import { CoinsStartingAt } from "./PDPDetailsComponents";
import MobileCardCustomizeActions from "./MobileCardCustomizeActions";
import MobileDrawer from "../Drawer/MobileDrawer";
import Share from "../Icons/Share";

import colors from "../../utils/colorConstants";
import { getIsMobileCustomizable } from "../../utils/cards";
import isServer from "../../utils/isServer";
import { isCompositionPremium } from "../../utils/compositions";

interface Props {
  className?: string;
  id?: string;
  compositionId: string;
  name: string;
  comps?: any;
  partner: any;
  favorite?: boolean;
  shareImage: string;
  eventType: string;
  customizeTrackingProps: any;
  coinsStartingAt?: number;
  customizeURL: string;
  productType: string;
  toggleValue?: any;
  toggleCallback?: any;
  setCoinModalOpen: any;
}

const FREE_PRIMARY_OPTIONS = [ 'Free', 'Premium' ];
const PREMIUM_PRIMARY_OPTIONS = [ 'Premium', 'Free' ];

const MobileActionsBar: FC<Props> = (props) => {
  const {
    id,
    compositionId,
    name,
    comps,
    partner,
    favorite,
    shareImage,
    eventType,
    coinsStartingAt,
    customizeTrackingProps,
    customizeURL,
    productType,
    toggleValue,
    toggleCallback,
    setCoinModalOpen,
  } = props;
  const isReady = !!(id && eventType && customizeURL && typeof coinsStartingAt === 'number');
  const [isShareDrawerOpen, setIsShareDrawerOpen] = useState(false);
  const openShareDrawer = useCallback(() => setIsShareDrawerOpen(true), [setIsShareDrawerOpen]);
  const closeShareDrawer = useCallback(() => setIsShareDrawerOpen(false), [setIsShareDrawerOpen]);

  return (
    <StickyContainer
      className="lg:hidden overflow-auto shadow-md p-4"
      height="7.25rem"
      isReady={isReady}
    >
      <div className="flex flex-row justify-between pb-4">
        {productType === "card" ? (
          <CoinsStartingAt
            coinsStartingAt={coinsStartingAt}
            questionClick={setCoinModalOpen}
          />
        ) : (
          <div className="flex items-center">
            <ToggleSwitch
              options={isCompositionPremium(comps[0]) ? PREMIUM_PRIMARY_OPTIONS : FREE_PRIMARY_OPTIONS}
              toggleValue={toggleValue}
              toggleCallback={toggleCallback}
            />
            <span
              className="text-gatsby cursor-pointer paragraph-medium ml-4"
              onClick={setCoinModalOpen}
            >
              Pricing
            </span>
          </div>
        )}
        <span className="flex items-center">
          {productType === "card" && id && (
            <CardFavoriteButton
              className="p-0"
              id={id}
              favorite={favorite}
              stroke={colors.lapel}
            />
          )}
          <div
            className="pl-6"
            role="button"
            onClick={openShareDrawer}
          >
            <Share />
          </div>
        </span>
      </div>
      {!isServer() && (
        <MobileCardCustomizeActions
          id={id}
          compositionId={compositionId}
          customizeURL={customizeURL}
          isMobileCustomizable={getIsMobileCustomizable(eventType)}
          productType={productType}
          customizeTrackingProps={customizeTrackingProps}
        />
      )}
      {isShareDrawerOpen && (
        <MobileDrawer
          direction="bottom"
          isOpen={isShareDrawerOpen}
          toggleCallback={closeShareDrawer}
          ariaLabel="Social sharing drawer"
          tracking={{ id: "pdpShareDrawer" }}
        >
          <ShareDrawerContents
            name={name}
            partner={partner}
            images={[shareImage]}
            shareURL={`https://www.paperlesspost.com/cards/card/${id}`}
            onDismiss={closeShareDrawer}
          />
        </MobileDrawer>
      )}
    </StickyContainer>
  );
};

export default memo(MobileActionsBar);
